import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { Props } from '../../../shared/assets/SvgProps';

const DropdownTickMark = ({ color = '#000000' }: Props) => (
  <Svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <Path
      d="M13.3332 4L5.99984 11.3333L2.6665 8"
      stroke={color}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);

export default DropdownTickMark;
